<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { computed, ref } from 'vue';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';
import { useAlert } from 'dashboard/composables';
import { formatBRL } from '../utils/reportFormatters';

// Card de compartilhamento da avaliação com o proprietário (WhatsApp, link
// copiável e abertura do relatório público).
const props = defineProps({
  ownerShare: { type: Object, default: () => ({}) },
  priceAnalysis: { type: Object, default: () => ({}) },
  disabled: { type: Boolean, default: false },
});

const shareCopied = ref(false);

const ownerShareUrl = computed(
  () => props.ownerShare.url || window.location.href
);
const ownerWhatsappMessage = computed(() => {
  if (props.ownerShare.whatsapp_text) return props.ownerShare.whatsapp_text;

  const price = props.priceAnalysis.suggested_value
    ? formatBRL(props.priceAnalysis.suggested_value)
    : 'um valor recomendado';

  return [
    'Olá, proprietário! Tudo bem?',
    `Preparei essa análise do melhor valor para o seu imóvel com base no que temos visto no mercado imobiliário da região. Levando em conta as características dele, o preço recomendado é de ${price}.`,
    `Neste link tem mais detalhes: ${ownerShareUrl.value}`,
  ].join('\n\n');
});
const ownerWhatsappUrl = computed(
  () => `https://wa.me/?text=${encodeURIComponent(ownerWhatsappMessage.value)}`
);

const copyOwnerShareLink = async () => {
  try {
    await navigator.clipboard.writeText(ownerShareUrl.value);
    shareCopied.value = true;
    useAlert('Link copiado com sucesso!');
    window.setTimeout(() => {
      shareCopied.value = false;
    }, 1800);
  } catch {
    useAlert('Não foi possível copiar o link.');
  }
};

const openOwnerWhatsapp = () => {
  window.open(ownerWhatsappUrl.value, '_blank', 'noopener,noreferrer');
};

const openOwnerReport = () => {
  window.open(ownerShareUrl.value, '_blank', 'noopener,noreferrer');
};
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <LaisCard title="Envie esta avaliação do imóvel para o proprietário">
    <p class="text-[13px] leading-relaxed text-lais-text-body">
      Compartilhe os resultados e garanta o melhor preço para o anúncio deste
      imóvel
    </p>
    <div class="mt-4 flex flex-col gap-2 sm:flex-row">
      <LaisPrimaryButton
        icon="i-lucide-message-circle"
        :disabled="disabled"
        @click="openOwnerWhatsapp"
      >
        Compartilhar no WhatsApp
      </LaisPrimaryButton>
      <LaisPrimaryButton
        variant="ghost"
        icon="i-lucide-copy"
        :disabled="disabled"
        @click="copyOwnerShareLink"
      >
        {{ shareCopied ? 'Copiado' : 'Copiar link' }}
      </LaisPrimaryButton>
      <LaisPrimaryButton
        variant="ghost"
        icon="i-lucide-external-link"
        :disabled="disabled"
        @click="openOwnerReport"
      >
        Abrir relatório
      </LaisPrimaryButton>
    </div>
    <label
      class="mt-4 block text-[11px] font-semibold uppercase tracking-wide text-lais-text-muted"
    >
      O link abaixo pode ser copiado e enviado
    </label>
    <input
      :value="ownerShareUrl"
      readonly
      class="mt-2 h-10 w-full rounded-lais border border-lais-border bg-white px-3 text-[13px] text-lais-text focus:border-lais-primary focus:outline-none"
    />
  </LaisCard>
</template>
